import { format } from 'date-fns';
import { Project } from '~/types/project';

export default function updatedAt(project: Project) {
  return project?.updatedAt ? `Last Edited On: ${format(new Date(project?.updatedAt), 'EEEE, MMMM d, yyyy, h:mm a')}` : '';
}